import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number | null | undefined, duration?: string): string {
  if (!price || price === 0) {
    return "Custom pricing";
  }
  return `$${price}${duration ? `/${duration}` : ''}`;
}
